import { INamedEntityRecognitionLabel } from '@scale/shared/types/params/namedentityrecognition';
import { labelsSchema } from '@scale/shared/taskTemplate/nerSchemas';
import ArrayBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/ArrayBuilder';
import { Button, Typography } from '@scale/scaleui';
import { useCallback } from 'react';
import type { TypeBuilderMapType } from 'react-scale/corp/components/QM/taskTemplatesEditor/BuilderSchemasType';

interface LabelsBuilderProps {
  name: string;
  description?: string;
  existingValue?: Array<INamedEntityRecognitionLabel>;
  updateProperty: (arg: Array<INamedEntityRecognitionLabel>) => void;
  toggleLabel?: (l: string) => void;
  isTopLevel?: boolean;
  typeBuilderMap: TypeBuilderMapType;
}

const LabelsBuilder: React.FC<LabelsBuilderProps> = ({
  name,
  description,
  existingValue: existingLabels = [],
  updateProperty,
  toggleLabel,
  isTopLevel,
  typeBuilderMap,
}) => {
  const addLabel = useCallback(() => {
    const labelPlaceholder = `label_${existingLabels.length + 1}`;
    updateProperty([...existingLabels, { name: labelPlaceholder, display_name: labelPlaceholder }]);
  }, [existingLabels, updateProperty]);
  return (
    <div className="flex flex-col gap-1">
      {name && <Typography.Subtitle3>{name}</Typography.Subtitle3>}
      {description && <Typography.Subtitle4>{description}</Typography.Subtitle4>}
      <ArrayBuilder
        typeBuilderMap={typeBuilderMap}
        elements={existingLabels}
        setElements={updateProperty}
        getKey={label => label.name}
        getTitle={label => label.display_name ?? ''}
        getSchema={() => labelsSchema}
        toggleLabel={toggleLabel}
        fullWidth
      />

      <div>
        <Button size="sm" onClick={addLabel} variant="outline">
          {isTopLevel ? 'Add Label' : 'Add Sub-Label'}
        </Button>
      </div>
    </div>
  );
};

export default LabelsBuilder;
